import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

type ArrowProps = {
  theme: any;
  isShowingDetails: boolean;
};

export const StyledButton = styled.button`
  color: #536f76;
  font-size: 14px;
  margin-right: 4px;
  background: none;
  outline: none;
  border: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const ButtonContent = styled.div`
  margin-right: 8px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  text-decoration: underline;
`;

export const Arrow = styled.div<ArrowProps>`
  border-style: solid;
  border-color: ${({ theme }) => theme.defaultColors.fontPrimary};
  border-width: 0 1px 1px 0;
  height: 6px;
  width: 6px;
  margin-top: ${({ isShowingDetails }) => (isShowingDetails ? '0' : '-3px')};
  margin-bottom: ${({ isShowingDetails }) => (isShowingDetails ? '-3px' : '0')};
  transform: ${({ isShowingDetails }) => (isShowingDetails ? 'rotate(-135deg)' : 'rotate(45deg)')};
  display: none;
  ${media.md`
    display: block;
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;
